import React, { useEffect, useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import PurchaseOrderTable from "../components/PurchaseOrderTable";
import LowStockAlertBanner from "../components/LowStockAlertBanner";
import DashboardWidgets from "../components/DashboardWidgets";
import { Typography } from "@mui/material";

export interface PurchaseOrder {
  _id: string;
  orderNumber: string;
  // Backend returns populated supplier object; allow either string or object
  supplier: any;
  status: string;
  totalAmount?: number;
  createdAt: string;
  expectedDate?: string;
  items?: Array<{ quantity: number; unitPrice: number }>;
}

const PurchaseOrdersListPage: React.FC = () => {
  useProtectedRoute();
  const { token } = useAuth();
  const [orders, setOrders] = useState<PurchaseOrder[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    // Align with backend: /api/inventory/po/all
    api.get("/inventory/po/all", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => setOrders(res.data))
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <div className="max-w-7xl mx-auto p-4 md:p-8">
      <Typography variant="h4" fontWeight={900} gutterBottom>Purchase Orders</Typography>
      <LowStockAlertBanner />
      <DashboardWidgets />
      <div className="flex justify-end mb-4">
        <button
          className="bg-blue-600 text-white px-6 py-2 rounded shadow"
          onClick={() => navigate("/purchase-orders/create")}
        >
          + New Purchase Order
        </button>
      </div>
      <PurchaseOrderTable orders={orders} loading={loading} onRowClick={id => navigate(`/purchase-orders/${id}`)} />
    </div>
  );
};
export default PurchaseOrdersListPage;
